import React, {createContext, useState} from 'react';
import PharmacyGenericAdminService from "../services/PharmacyGenericAdminService";
import confirmationModal from "../components/common/ConfirmationModal";

export const PharmacyGenericAdminContext = createContext("PharmacyGenericAdminContext");

const PharmacyGenericAdminContextProvider = ({children}) => {

    const [generics, setGenerics] = useState(null);
    const [generic, setGeneric] = useState();
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [totalElements, setTotalElements] = useState('');

    const getAllGenerics = async ({page, size, id, genericName}) => {

        try {
            setLoading(true);
            setErrorMsg('');
            const res = await PharmacyGenericAdminService.getAllForAdmin(page, size, id, genericName);
            setGenerics(res.data.content)
            setTotalElements(res.data.totalElements);
            setLoading(false);
            return res.data.content;
        } catch (error) {
            setErrorMsg("Can not load Generics. Please check the console.");
            console.log("error", console.error());
            return false;
        }

    }

    const getGenericById = async (id) => {

        try {
            setLoading(true);
            setErrorMsg('');
            const res = await PharmacyGenericAdminService.getGenericForAdmin(id);
            setGeneric(res.data);
            setLoading(false);
            return 200;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not load Generics. Please check the console.");
            console.log("error", error)
            return error.response ? error.response.status : 500;
        }

    }

    const addGeneric = async (data) => {

        try {
            setErrorMsg('');
            setLoading(true);
            const res = await PharmacyGenericAdminService.savePharmacyGenericForAdmin(data)
            setGeneric(res.data);
            setLoading(false);
            confirmationModal(`Generic Id - ${res.data.id} saved successfully. `, "success");
            return true;
        } catch (err) {
            const message = err.response ? err.response.data.message : err.message;
            setErrorMsg("Can not add Generics. Please check the console.");
            console.log("post generic error", message);
            confirmationModal("Can not save Generic. " + message, "error");
            return false;
        }

    }

    const updateGeneric = async (data, id) => {
        try {
            setLoading(true);
            setErrorMsg('');
            const res = await PharmacyGenericAdminService.updatePharmacyGenericForAdmin(data, id);
            setGeneric(res.data);
            setLoading(false);
            confirmationModal(`Generic Id - ${res.data.id} updated successfully!`, "success");
            return true;
        } catch (error) {
            setErrorMsg("Can not update Generic. Please check the console.");
            console.log("Generic update error.", error);
            confirmationModal("Generic updated failed. ", "error");
            return false;
        }

    }

    return (
        <PharmacyGenericAdminContext.Provider
            value={{
                generics,
                generic,
                getGenericById,
                loading,
                errorMsg,
                totalElements,
                getAllGenerics,
                updateGeneric,
                addGeneric
            }}
        >
            {children}
        </PharmacyGenericAdminContext.Provider>
    );
}

export default PharmacyGenericAdminContextProvider;
